<template>
  <div class="flex-1">
    <div
      v-if="initialLoadingDone && count.total === 0"
      class="container container--full pdgx"
    >
      <h2 class="text-h3 mrgb0">
        Für die gewählte Filterkombination konnten keine Resultate gefunden
        werden.
      </h2>
      <div class="text-normal text-h5 text-light mrgt-- mrgb">
        Entferne die gesetzten Filter um die Suche zu erweitern.
      </div>
      <button type="button" class="btn btn--primary" @click="removeAllItems">
        Alle Filter zurücksetzen
      </button>
    </div>
    <day v-for="(result, key) in resultsByDay" :key="key" :day="result"></day>
    <template v-if="loading">
      <day v-for="n in 2" :key="n" :loading="true"></day>
    </template>
    <div v-if="resultsLeftToLoad > 0 && count.total > 0" class="separator pdgx">
      <button class="btn btn--primary separator__btn" @click.prevent="nextPage">
        Mehr laden
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Day from './Day'

export default {
  components: {
    Day
  },

  props: {},

  computed: {
    ...mapState('Results', {
      resultsByDay: (state) => state.resultsByDay,
      count: (state) => state.count,
      loading: (state) => state.loading
    }),

    ...mapState({
      initialLoadingDone: 'initialLoadingDone'
    }),

    ...mapGetters({
      resultsLeftToLoad: 'Results/resultsLeftToLoad'
    })
  },

  methods: {
    /**
     * Loads the next few results when no initLimit is set,
     * else redirect to the complete search results.
     */
    nextPage() {
      this.$store.dispatch('Results/loadNextPage')
    },

    removeAllItems() {
      this.$store.commit('Selected/removeAllItems')
      this.$store.dispatch('Results/load', {})
    }
  }
}
</script>
